import React from 'react';
import { useTranslation } from 'react-i18next';

const DetailCellRenderer = () => {
    const { t } = useTranslation();
    return <h1 style={{ padding: '20px' }}>{t('myCustomDetail')}</h1>
};

export default DetailCellRenderer;
